import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

import { ModalContents } from './ModalContents';

interface AddNewDataModalProps {
  setOpenAddNewDataModal: Dispatch<SetStateAction<boolean>>;
  setDetectChangingData: Dispatch<SetStateAction<boolean>>;
  apartmentIdx: number;
}

export const AddNewDataModal = ({
  setOpenAddNewDataModal,
  setDetectChangingData,
  apartmentIdx,

}: AddNewDataModalProps) => {
  const closeModal = () => {
    setOpenAddNewDataModal(false);
  };

  return (
    //모달 외부 클릭시 화면이 닫치지 않도록 개선 - 2025.09.29
    //<Background onClick={closeModal}>
    <Background>
      <Container
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <ModalContents closeModal={closeModal} apartmentIdx={apartmentIdx} setDetectChangingData={setDetectChangingData} />
      </Container>
    </Background>
  );
};

const Background = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* rgba(0, 0, 0, 0.3) */
  z-index: 999;
`;

const Container = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: white;
`;
